// userSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'api/axios';
import { clearLocalStorage } from 'utils/functions/localStorage';
import { clearSession, setJwtToken, getJwtToken } from 'utils/functions/session-storage';
import { HOST } from 'variables';

export const refreshSession = createAsyncThunk('user/refreshSesion', async ({ headers }) => {
  const response = await axios.get(`${HOST}/accounts/refresh`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getJwtToken()}`
    }
  });

  const token = await response.data.token;

  setJwtToken(token);

  return token;
});

export const getPermissions = createAsyncThunk('user/getPermissions', async ({ headers, btype, pmtr_acct }) => {
  const response = await axios.get(`${HOST}/ext/planimator/${btype}/account/myaccess`, {
    headers: headers,
    params: { ref: pmtr_acct }
  });

  const data = response.data;

  const permissions = data?.map((permission) => {
    return permission.feature_code;
  });

  if (permissions) sessionStorage.setItem('permissions', JSON.stringify(permissions));

  return permissions;
});

const initialState = {
  error: null,
  user: null,
  isLoggedIn: false,
  permissions: [],
  token: getJwtToken()
};

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // refreshSession: (state, action) => {
    //   setJwtToken(action.payload);
    //   state.token = action.payload;
    // },
    login: (state, action) => {
      state.user = action.payload;
      state.permissions = action.payload.permissions;
      state.isLoggedIn = true;
      sessionStorage.setItem('token', action.payload.token);
      sessionStorage.setItem('name', action.payload.username);
      sessionStorage.setItem('organization', action.payload.organization);
    },
    logout: (state) => {
      // Clear session and local storage
      clearSession();
      clearLocalStorage();

      // Reset user state
      state.user = null;
      state.isLoggedIn = false;
      state.permissions = [];
      state.token = null;

      // Note: baseApi.util.resetApiState() should be dispatched from the component
      // or handled in a root reducer to clear the RTK Query cache.
    }
  },
  extraReducers: (builder) => {
    builder
      // Case for zones
      .addCase(refreshSession.pending, (state) => {})
      .addCase(refreshSession.fulfilled, (state, action) => {
        state.token = action.payload;
      })
      .addCase(refreshSession.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(getPermissions.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
        state.permissions = action.payload;
      });
  }
});

export const { login, logout } = user.actions;

export const selectUser = (state) => state.user.user;
export const selectIsLoggedIn = (state) => state.user.isLoggedIn;

export default user.reducer;
